import React, { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";

const META_ROBOTS =
	"noindex, nofollow, noarchive, nosnippet, noimageindex";

/**
 * Layout para páginas legales: meta robots para no indexación.
 * Usar solo en rutas /legal/*
 * - Meta robots en head (también respetado por crawlers que ejecutan JS)
 * - robots.txt con Disallow: /legal/ evita que se rastreen esas URLs
 */
export default function LegalLayout({ title, children }) {
	useLayoutEffect(() => {
		document.title = `${title} · Viajes Molones`;
		let meta = document.querySelector('meta[name="robots"][data-legal]');
		if (!meta) {
			meta = document.createElement("meta");
			meta.name = "robots";
			meta.setAttribute("data-legal", "true");
			document.head.appendChild(meta);
		}
		meta.content = META_ROBOTS;
		return () => {
			if (meta && meta.parentNode) document.head.removeChild(meta);
		};
	}, [title]);

	return (
		<Box
			component="main"
			sx={{
				background: "linear-gradient(180deg, #F8FAFC 0%, #F1F5F9 100%)",
				minHeight: "100vh",
				py: 4,
				px: 3,
			}}
		>
			<Box sx={{ maxWidth: 720, margin: "0 auto" }}>
				<Link
					to="/"
					rel="nofollow"
					style={{
						display: "inline-flex",
						alignItems: "center",
						gap: 8,
						color: "#6366F1",
						textDecoration: "none",
						fontSize: "0.875rem",
						marginBottom: 24,
					}}
				>
					← Volver al inicio
				</Link>
				<Box
					component="article"
					sx={{
						backgroundColor: "#fff",
						borderRadius: 1,
						border: "1px solid rgba(0,0,0,0.08)",
						p: 3,
						lineHeight: 1.65,
						color: "#0f172a",
						fontSize: "1rem",
					}}
				>
					{children}
				</Box>
			</Box>
		</Box>
	);
}
